import React, { useContext, useState } from "react";
import { Button, Input } from "reactstrap";
import UserIcon from "../images/user1.png";
import { DatePicker } from "reactstrap-date-picker";
import { MdOutlineDateRange } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { PiInfinityBold } from "react-icons/pi";
import NoImage from "../images/no-image.png";
import { RiDeleteBin6Line } from "react-icons/ri";
import moment from "moment";
import swal from "sweetalert";
import { DataContext } from "../context/DataContext";
function AccessList(props) {
  const ListRow = ({ item, onUpdate, showDelete }) => {
    // console.log(item);
    const [update, setupdate] = useState(false);
    const [expirydate, setExpirydate] = useState(
      item?.expiryDate || null
    );
    const [permissiontype, setPermissiontype] = useState(
      item?.permissionType
    );
    return (
      <tr key={item?._id}>
        <td>
          <img
            className="userImg memberIcon "
            src={item?.profilePhoto || NoImage}
            alt="user"
            referrerPolicy="no-referrer"
          />
          <div className="userName">
            {item?.name}
            <span>{item?.email}</span>
          </div>
        </td>
        {props?.details ? (
          <td width={"25%"}>
            <label>Expiry Date</label>
            {update ? (
              <div className="formElmWrap dateWrap">
                <DatePicker
                  showClearButton={true}
                  placeholder="Expiry Date"
                  minDate={new Date().toDateString()}
                  value={expirydate}
                  onChange={(e) => setExpirydate(e?.split("T")[0])}
                />
                <span className="formIcon dateIcon">
                  {<MdOutlineDateRange />}
                </span>
              </div>
            ) : (
              <span className="userName">
                {item?.expiryDate ? (
                  <>{moment(item?.expiryDate).format("ll")}</>
                ) : (
                  <PiInfinityBold style={{ height: 25, width: 25 }} />
                )}
              </span>
            )}
          </td>
        ) : null}
        {props?.details ? (
          <td width={"25%"}>
            <label>Access Type</label>
            {update ? (
              <div className="formElmWrap">
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={permissiontype}
                  onChange={(e) => {
                    setPermissiontype(e.target.value);
                  }}
                >
                  <option>View</option>
                  <option>Edit</option>
                </Input>
              </div>
            ) : (
              <span className="userName">{item?.permissionType}</span>
            )}
          </td>
        ) : null}
        <td className="btnTd">
          {update ? (
            <Button
              color="primary"
              onClick={() =>
                onUpdate(
                  {
                    permissionType: permissiontype,
                    expiryDate: expirydate,
                    shareWith: item?.userId,
                  },
                  item?.permissionId
                )
              }
            >
              Update
            </Button>
          ) : (
            <>
              {props?.details ? (
                <Button
                  className="editBtn"
                  onClick={() => setupdate(true)}
                >
                  <TbEdit />
                </Button>
              ) : null}
              {showDelete && (
                <Button
                  className="editBtn"
                  onClick={async () => {
                    const willDelete = await swal({
                      title: "Remove Access",
                      text: "Are you sure?<br> We strongly recommend that you change the password before deleting it.",
                      icon: "warning",
                      dangerMode: true,
                      buttons: "confirm",
                    });

                    if (willDelete) {
                      props?.onDelete(
                        item?.sharedId,
                        item?.permissionId
                      );
                    }
                  }}
                >
                  <RiDeleteBin6Line />
                </Button>
              )}
            </>
          )}
        </td>
      </tr>
    );
  };
  return (
    <div className="accessTable">
      <h3>People with access</h3>
      <table className="table">
        <tbody styles={{ height: "500px", overflowY: "scroll" }}>
          {props.pwAccess?.map((item, index) => {
            return (
              <ListRow
                item={item}
                key={index + "pw"}
                onUpdate={(data, pId) => props?.onUpdate(data, pId)}
                showDelete={
                  props?.deleteOption === "password" ? true : false
                }
              />
            );
          })}
          {props.envAccess?.map((item, index) => {
            return (
              <ListRow
                item={item}
                key={index + "env"}
                onUpdate={(data, pId) => props?.onCreate(data, pId)}
                showDelete={
                  props?.deleteOption === "env" ? true : false
                }
              />
            );
          })}
          {props.folderAccess?.map((item, index) => {
            return (
              <ListRow
                item={item}
                key={index + "f"}
                onUpdate={(data, pId) => props?.onCreate(data, pId)}
                showDelete={
                  props?.deleteOption === "folder" ? true : false
                }
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default AccessList;
